/** Annuitetsbetalning per månad, exklusive avgifter. */
export function annuity(principal: number, months: number, annualRatePct: number) {
  const i = annualRatePct / 100 / 12;
  if (i === 0) return principal / months;
  return (principal * i) / (1 - Math.pow(1 + i, -months));
}

/**
 * Effektiv ränta enligt konsumentkreditlagens modell: alla avgifter inräknade,
 * uträknad som internräntan på det faktiskt utbetalda beloppet.
 */
export function effectiveRate(
  principal: number,
  months: number,
  annualRatePct: number,
  setupFee = 0,
  monthlyFee = 0,
) {
  const payment = annuity(principal, months, annualRatePct) + monthlyFee;
  const net = principal - setupFee;
  let lo = 0;
  let hi = 1; // 100 % månadsränta som övre gräns
  for (let n = 0; n < 200; n++) {
    const mid = (lo + hi) / 2;
    const pv =
      mid === 0 ? payment * months : (payment * (1 - Math.pow(1 + mid, -months))) / mid;
    if (pv > net) lo = mid;
    else hi = mid;
  }
  const i = (lo + hi) / 2;
  return (Math.pow(1 + i, 12) - 1) * 100;
}

export function totalCost(principal: number, months: number, annualRatePct: number, setupFee = 0, monthlyFee = 0) {
  return (annuity(principal, months, annualRatePct) + monthlyFee) * months + setupFee;
}
